<template>
  <q-page padding>
    <div class="container">
      <div class="row q-col-gutter-md">
        <div class="col-12">
          <!-- Interface do Chat IA para clientes com acesso -->
          <div v-if="clienteTemAcessoIA" class="ia-chat-container">
            <!-- Call to Action para Tutorial -->
            <div class="tutorial-section q-mb-lg">
              <q-card flat bordered class="tutorial-card">
                <q-card-section class="text-center">
                  <h6 class="text-h6 text-weight-medium q-mb-sm tutorial-title">
                    Tutorial de Uso da IA Multpex
                  </h6>
                  <p class="text-body2 text-grey-7 q-mb-md">
                    Veja aqui um tutorial de uso e os benefícios da IA da
                    Multpex
                  </p>
                  <q-btn
                    color="primary"
                    :icon="mostrarTutorial ? 'close' : 'play_arrow'"
                    :label="
                      mostrarTutorial ? 'Fechar Tutorial' : 'Ver Tutorial'
                    "
                    @click="mostrarTutorial = !mostrarTutorial"
                    :outline="!mostrarTutorial"
                    :unelevated="mostrarTutorial"
                  />
                </q-card-section>

                <!-- Iframe do Google Slides -->
                <q-slide-transition>
                  <div v-show="mostrarTutorial" class="q-pa-md">
                    <iframe
                      src="https://docs.google.com/presentation/d/e/2PACX-1vSPtt8BfxRV19kG9yDHjdF5f00n0LUOs7nkYtr9qYZg-ZaIIABCP0fqhNmySwhAfDI3ae9b47wHW6DI/embed?start=false&loop=true&delayms=3000"
                      frameborder="0"
                      allowfullscreen="true"
                      mozallowfullscreen="true"
                      webkitallowfullscreen="true"
                      class="tutorial-iframe"
                    ></iframe>
                  </div>
                </q-slide-transition>
              </q-card>
            </div>

            <!-- Banner de Introdução ao Assistente IA -->
            <div v-if="showIABanner" class="q-mb-lg">
              <IABanner @close="closeIABanner" />
            </div>

            <div class="q-mb-md">
              <div class="row items-center justify-between">
                <div class="col">
                  <h4 class="text-h4 text-weight-medium q-mb-sm">
                    <q-icon name="smart_toy" class="q-mr-sm" />
                    Assistente IA Multpex
                  </h4>
                  <p class="text-body1 text-grey-7">
                    Converse com nosso assistente inteligente para tirar dúvidas
                    sobre EPIs, procedimentos de segurança e muito mais.
                  </p>
                </div>
                <div class="col-auto">
                  <q-btn
                    color="primary"
                    outline
                    icon="event_note"
                    label="Meus Agendamentos"
                    @click="abrirGestaoAgendamentos"
                    class="q-ml-md"
                  />
                </div>
              </div>
            </div>

            <ChatIA
              :assistente-ativado="assistenteAtivado || !showIABanner"
              :cliente="store.state.autenticacao.cliente[0]"
              @abrir-gestao-agendamentos="abrirGestaoAgendamentos"
              class="ia-chat-component"
            />
          </div>

          <!-- Mensagem comercial para usuários sem acesso -->
          <div v-else class="text-center q-pa-xl">
            <q-icon
              name="smart_toy"
              size="6rem"
              color="primary"
              class="q-mb-lg"
            />
            <h4 class="text-h4 text-weight-bold q-mb-md text-primary">
              🚀 Assistente IA Multpex
            </h4>
            <h6 class="text-h6 text-weight-medium q-mb-lg text-grey-8">
              Revolucione sua gestão de EPIs com inteligência artificial!
            </h6>

            <div class="q-mb-xl">
              <p class="text-body1 text-grey-7 q-mb-md">
                🤖 <strong>Converse naturalmente</strong> sobre dúvidas de uso
                do sistema, trocas e consumo de produtos.
              </p>
              <p class="text-body1 text-grey-7 q-mb-md">
                ⚡ <strong>Respostas instantâneas</strong> baseadas no uso do
                seu sistema e análises agendadas e automatizadas no seu
                WhatsApp.
              </p>
              <p class="text-body1 text-grey-7 q-mb-md">
                🎯 <strong>Suporte especializado</strong> 24/7
              </p>
            </div>

            <div class="q-gutter-md">
              <q-btn
                size="lg"
                color="positive"
                icon="phone"
                label="Falar com Vendas"
                @click="abrirWhatsAppVendas"
                class="q-px-xl"
              />
              <q-btn
                size="lg"
                color="primary"
                outline
                icon="email"
                label="Solicitar Demonstração"
                @click="abrirEmailComercial"
                class="q-px-xl"
              />
            </div>

            <div class="q-mt-xl text-caption text-grey-6">
              <p>
                📞 Entre em contato e descubra como a IA pode transformar sua
                gestão!
              </p>
            </div>

            <!-- Call to Action para Tutorial (Usuários sem acesso) -->
            <div class="tutorial-section q-mt-xl">
              <q-card flat bordered class="tutorial-card">
                <q-card-section class="text-center">
                  <h6 class="text-h6 text-weight-medium q-mb-sm tutorial-title">
                    Tutorial de Uso da IA Multpex
                  </h6>
                  <p class="text-body2 text-grey-7 q-mb-md">
                    Veja aqui um tutorial de uso e os benefícios da IA da
                    Multpex
                  </p>
                  <q-btn
                    color="primary"
                    :icon="mostrarTutorial ? 'close' : 'play_arrow'"
                    :label="
                      mostrarTutorial ? 'Fechar Tutorial' : 'Ver Tutorial'
                    "
                    @click="mostrarTutorial = !mostrarTutorial"
                    :outline="!mostrarTutorial"
                    :unelevated="mostrarTutorial"
                  />
                </q-card-section>

                <!-- Iframe do Google Slides -->
                <q-slide-transition>
                  <div v-show="mostrarTutorial" class="q-pa-md">
                    <iframe
                      src="https://docs.google.com/presentation/d/e/2PACX-1vSPtt8BfxRV19kG9yDHjdF5f00n0LUOs7nkYtr9qYZg-ZaIIABCP0fqhNmySwhAfDI3ae9b47wHW6DI/embed?start=false&loop=true&delayms=3000"
                      frameborder="0"
                      allowfullscreen="true"
                      mozallowfullscreen="true"
                      webkitallowfullscreen="true"
                      class="tutorial-iframe"
                    ></iframe>
                  </div>
                </q-slide-transition>
              </q-card>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Gestão de Agendamentos -->
    <GestaoAgendamentosModal v-model="mostrarGestaoAgendamentos" />
  </q-page>
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import ChatIA from "../components/ChatIA.vue";
import IABanner from "../components/IABanner.vue";
import GestaoAgendamentosModal from "../components/GestaoAgendamentosModal.vue";
import { clienteTemAcessoIA } from "../services/iaAccessControl";

export default {
  name: "FaleComIA",
  components: {
    ChatIA,
    IABanner,
    GestaoAgendamentosModal,
  },
  setup() {
    const store = useStore();
    const showIABanner = ref(true);
    const assistenteAtivado = ref(false);
    const mostrarGestaoAgendamentos = ref(false);
    const mostrarTutorial = ref(false);

    const temAcessoIA = computed(() => clienteTemAcessoIA(store));

    const closeIABanner = () => {
      showIABanner.value = false;
      assistenteAtivado.value = true;
    };

    const abrirGestaoAgendamentos = () => {
      mostrarGestaoAgendamentos.value = true;
    };

    const abrirWhatsAppVendas = () => {
      const numero = "5515997209125";
      const mensagem = encodeURIComponent(
        "Olá! Gostaria de saber mais sobre o Assistente IA Multpex para gestão de EPIs. Podem me enviar mais informações?"
      );
      window.open(`https://wa.me/${numero}?text=${mensagem}`, "_blank");
    };

    const abrirEmailComercial = () => {
      const email = "vendas@multpex.com.br";
      const assunto = encodeURIComponent(
        "Solicitação de Demonstração - Assistente IA Multpex"
      );
      const corpo = encodeURIComponent(
        "Olá equipe Multpex,\n\nGostaria de agendar uma demonstração do Assistente IA para gestão de EPIs.\n\nPor favor, entrem em contato para agendarmos uma apresentação.\n\nObrigado!"
      );
      window.open(`mailto:${email}?subject=${assunto}&body=${corpo}`, "_blank");
    };

    return {
      store,
      showIABanner,
      assistenteAtivado,
      mostrarGestaoAgendamentos,
      mostrarTutorial,
      clienteTemAcessoIA: temAcessoIA,
      closeIABanner,
      abrirGestaoAgendamentos,
      abrirWhatsAppVendas,
      abrirEmailComercial,
    };
  },
};
</script>

<style scoped>
.ia-chat-container {
  min-height: 70vh;
}

.ia-chat-component {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.tutorial-iframe {
  width: 100%;
  height: 600px;
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  display: block;
  margin: 0 auto;
}

.tutorial-card {
  border: 1px solid #e0e0e0;
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  overflow: hidden;
}

.tutorial-section {
  max-width: 100%;
  margin: 1 auto;
}

.tutorial-title {
  margin-top: 0px !important;
}

@media (max-width: 768px) {
  .q-gutter-md > .q-btn {
    width: 100%;
    margin-bottom: 12px;
  }

  .row.items-center.justify-between {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .col-auto {
    width: 100%;
    margin-top: 16px;
  }

  .col-auto .q-btn {
    width: 100%;
  }

  .tutorial-iframe {
    height: 500px;
    margin: 0;
  }

  .tutorial-card {
    margin: 0 -8px;
  }
}
</style>
